import { withNaming } from '@bem-react/classname';
export var NAMESPACE = 'yc-';
export var cn = withNaming({
  e: '__',
  m: '_'
});
export var block = withNaming({
  n: NAMESPACE,
  e: '__',
  m: '_'
});
// #sourceMappingURL=cn.js.map